import controller from './my-details.controller'
import template   from './my-details.html'
import './my-details.styl'

let component = {
  restrict: 'E',
  transclude: true,
  controller,
  template
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/profile/my-profile/my-details/my-details.component.js